(function () {
  'use strict';

  function initDrawerRightSlide() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    var details = headerDrawer.querySelector('details');
    var summary = headerDrawer.querySelector('summary');
    var drawer = headerDrawer.querySelector('.menu-drawer');
    if (!details || !summary || !drawer) return;

    // Force initial hidden state on the RIGHT
    drawer.style.left = 'auto';
    drawer.style.right = '0';
    drawer.style.transform = 'translateX(100%)';
    drawer.style.visibility = 'hidden';

    drawer.offsetHeight;

    var isOpen = false;

    function openDrawer() {
      isOpen = true;
    
      drawer.style.visibility = 'visible';
      requestAnimationFrame(function () {
        drawer.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
        drawer.style.transform = 'translateX(0)';
      });

      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
      document.documentElement.classList.add('ncg-drawer-open');
      document.body.classList.add('overflow-hidden');
    }

    function closeDrawer() {
      isOpen = false;
      drawer.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.35s';
      drawer.style.transform = 'translateX(100%)';

      setTimeout(function () {
        if (!isOpen) {
          drawer.style.visibility = 'hidden';
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
          }
        }
      }, 350);

      document.documentElement.classList.remove('ncg-drawer-open');
      document.body.classList.remove('overflow-hidden');
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (drawer.contains(e.target) || summary.contains(e.target)) return;
    
      closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeDrawer();
      }
    });

    drawer.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.menu-drawer__close-button');
      if (closeBtn && closeBtn.closest('summary')) {
        e.preventDefault();
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerRightSlide);
  } else {
    initDrawerRightSlide();
  }
})();